// core/stores/quoteDraftStore.ts — 1.21.00 Slice 2: carries the post a user just
// tapped "Quote" on across a navigation, so the Composer (Home-only today — see
// features/home/Composer.tsx) can pick it up and prefill the embedded preview
// even when "Quote" was tapped from a feed card, hero card, or post-detail page
// that isn't Home itself. Cleared once the composer consumes it (submit or
// explicit cancel), so it never lingers and re-attaches to an unrelated post.

import { create } from 'zustand';
import type { Post } from '@/core/models/post';

interface QuoteDraftState {
  pendingQuote: Post | null;
  setPendingQuote: (post: Post) => void;
  clearPendingQuote: () => void;
}

export const useQuoteDraftStore = create<QuoteDraftState>((set) => ({
  pendingQuote: null,
  setPendingQuote: (post) => set({ pendingQuote: post }),
  clearPendingQuote: () => set({ pendingQuote: null }),
}));
